@if (!recoveryComplete()) {
  <app-window class="reset-password">
    <span title>{{ 'features.resetPassword.title' | translate }}</span>
    <div body>
      <form class="reset-password-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="reset-password-form__title">
          <h2>{{ 'features.resetPassword.title' | translate }}</h2>
        </div>

        @if (errorMessage()) {
          <p class="reset-password__error">*{{ 'features.resetPassword.form.errors.notWorking' | translate }}</p>
        }

        <div class="reset-password-form__input">
          <label for="email">{{ 'features.resetPassword.email' | translate }}</label>
          <input name="email" type="email" id="email" formControlName="email" />
        </div>
        <div class="reset-password-form__buttons">
          <button class="main-button" [disabled]="form.invalid || isSubmitting()">
            {{ 'features.resetPassword.button' | translate }}
          </button>
        </div>
      </form>
    </div>
  </app-window>
} @else {
  <app-window class="reset-password">
    <span title>{{ 'features.resetPassword.title' | translate }}</span>
    <div class="reset-password__container" body>
      <p>{{ 'features.resetPassword.checkEmail' | translate }}.</p>
      <a routerLink="/user/login">{{ 'features.resetPassword.goToLogin' | translate }}</a>
    </div>
  </app-window>
}
